module.exports = __webpack_public_path__ + "img/banner01.2c7a4343.png";